
define('text!views/savings/saving_create_btn.html',[],function () { return '<span class="saving-create-new-plus-icon">+</span>\r\n<div class="saving-create-new-content-container">\r\n\t<p class="saving-create-new-text">Create a New Account</p>\r\n</div>';});

